export enum DisableDeleteCategories{
    NewModule ="New Module",
    ConsultationForms = "Consultation Forms",
    Survey = "Survey",
    OrganisationForms= "Organisation Forms"
}